window.global ||= window;
// https://stackoverflow.com/questions/72114775/vite-global-is-not-defined
// The problem is because  vite doesn't define a global field in window as webpack does. And some libraries relies on it since webpack is much more older than vite.
